<template>
  <label
    :id="id"
    class="form-label clic-hint"
    style="margin: 0px !important;"
    :key="componentKey"
    v-show="visible"
    @click="showModal = true"
    @mouseenter="showPopoverWithDelay"
    @mouseleave="hidePopover"
    @focusin="showPopoverWithDelay"
    @focusout="hidePopover"
  >

    <ClicIconInterno
      :cp="cp"
      class="btn clic-hint-trigger"
      iconName="bi-info-circle"
      iconScale="1.3"
      @click.native.stop="showModal = true"
    />

    <!-- Modal customizado leve (substitui b-modal) -->
    <div v-if="showModal" class="custom-modal-overlay" @click.stop @click.self="showModal = false">
      <div class="custom-modal" @click.stop>
        <div class="custom-modal-header">
          <h5>{{ translatedTitle }}</h5>
          <button type="button" class="custom-modal-close" @click="showModal = false">&times;</button>
        </div>
        <div class="custom-modal-body">
          <p v-html="translatedText"></p>
        </div>
      </div>
    </div>

    <!-- Popover customizado leve (substitui b-popover) -->
    <div
      v-if="windowWidth > 1024 && showPopover"
      class="custom-popover"
      @mouseenter="showPopover = true"
      @mouseleave="hidePopover"
    >
      <div class="custom-popover-title">
        {{ translatedTitle }}
      </div>
      <div class="custom-popover-content">
        <p v-html="translatedText"></p>
      </div>
    </div>

  </label>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';

export default {
  name : 'ClicHint',
  mixins: [ComponentMixin],

  data(){
    return{
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
      id : this.$utils.getComponentID(),
      showModal: false,
      showPopover: false,
      popoverTimer: null
    }
  },

  beforeDestroy() {
    this.clearPopoverTimer();
  },

  computed: {
    translatedTitle() {
      return this.getTranslatedText(this.title);
    },

    translatedText() {
      return this.getTranslatedText(this.text);
    }
  },

  methods: {
    showPopoverWithDelay() {
      this.clearPopoverTimer();
      this.popoverTimer = setTimeout(() => {
        this.showPopover = true;
      }, 300);
    },

    hidePopover() {
      this.clearPopoverTimer();
      this.popoverTimer = setTimeout(() => {
        this.showPopover = false;
        this.popoverTimer = null;
      }, 120);
    },

    clearPopoverTimer() {
      if (this.popoverTimer) {
        clearTimeout(this.popoverTimer);
        this.popoverTimer = null;
      }
    },

    getTranslatedText(value) {
      return this.$storage.getTextoTraduzido(value);
    }
  }
};
</script>

<style scoped>
.clic-hint {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.clic-hint-trigger {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: var(--blue);
}

/* Modal customizado */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.22);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.custom-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.custom-modal-header h5 {
  margin: 0;
}

.custom-modal-close {
  background: transparent;
  border: 0;
  color: #6b7280;
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  padding: 0 4px;
}

.custom-modal-body {
  padding: 15px;
  overflow-y: auto;
}

.custom-modal-footer {
  padding: 15px;
  border-top: 1px solid #ddd;
  text-align: right;
}

.custom-modal-button {
  background: var(--blue);
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
  padding: 8px 16px;
}

/* Popover customizado */
.custom-popover {
  position: absolute;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  color: #1f2937;
  max-width: 280px;
  min-width: 220px;
  z-index: 9998;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.18), 0 2px 8px rgba(15, 23, 42, 0.08);
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  overflow: visible;
  text-align: left;
}

.custom-popover-title {
  background: #fff;
  color: #0f3f75;
  font-weight: bold;
  line-height: 1.25;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px 8px 0 0;
  padding: 10px 12px;
}

.custom-popover-content {
  padding: 10px 12px 12px;
}

.custom-popover-content p {
  color: #374151;
  line-height: 1.45;
  margin: 0;
}

/* Seta do popover */
.custom-popover:before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 7px solid transparent;
  border-bottom-color: rgba(15, 23, 42, 0.12);
}

.custom-popover:after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: #fff;
}
</style>
